import "./editorialForms.css";

const categories = [
  { id: "vehicles", name: "Veículos" },
  { id: "real_estate", name: "Imóveis" },
  { id: "electronics", name: "Eletrônicos" },
  { id: "furniture", name: "Móveis" },
  { id: "appliances", name: "Eletrodomésticos" },
  { id: "fashion", name: "Moda" },
  { id: "sports", name: "Esportes" },
  { id: "pets", name: "Animais" },
  { id: "jobs", name: "Empregos" },
  { id: "services", name: "Serviços" },
  { id: "other", name: "Outros" },
];

const conditions = [
  { id: "new", name: "Novo" },
  { id: "like_new", name: "Seminovo" },
  { id: "good", name: "Bom estado" },
  { id: "fair", name: "Estado regular" },
  { id: "parts", name: "Para peças" },
];

const contactPreferences = [
  { id: "phone", name: "Telefone" },
  { id: "email", name: "E-mail" },
  { id: "message", name: "Mensagem" },
  { id: "any", name: "Qualquer um" },
];

export default function ClassifiedForm({ data, onChange }) {
  return (
    <div className="editorial_form classified_form">
      <div className="editorial_form_section">
        <label>
          Título do Anúncio <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: iPhone 13 Pro Max 256GB"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva o item em detalhes, estado de conservação, motivo da venda..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Subcategoria</label>
          <input
            type="text"
            placeholder="Ex: Smartphones, Casas, Carros..."
            value={data?.subcategory || ""}
            onChange={(e) => onChange({ ...data, subcategory: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Condição</label>
          <select
            value={data?.condition || ""}
            onChange={(e) => onChange({ ...data, condition: e.target.value })}
          >
            <option value="">Selecione</option>
            {conditions.map((cond) => (
              <option key={cond.id} value={cond.id}>
                {cond.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>
            Preço (R$) <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.price || ""}
            onChange={(e) =>
              onChange({ ...data, price: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="negotiable"
            checked={data?.negotiable !== false}
            onChange={(e) => onChange({ ...data, negotiable: e.target.checked })}
          />
          <label htmlFor="negotiable">Aceito negociação</label>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Localização</label>
        <input
          type="text"
          placeholder="Cidade, Estado"
          value={data?.location || ""}
          onChange={(e) => onChange({ ...data, location: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Telefone de Contato</label>
          <input
            type="tel"
            placeholder="(11) 99999-9999"
            value={data?.contactPhone || ""}
            onChange={(e) => onChange({ ...data, contactPhone: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>E-mail de Contato</label>
          <input
            type="email"
            placeholder="email@exemplo.com"
            value={data?.contactEmail || ""}
            onChange={(e) => onChange({ ...data, contactEmail: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Preferência de Contato</label>
        <select
          value={data?.preferredContact || "any"}
          onChange={(e) => onChange({ ...data, preferredContact: e.target.value })}
        >
          {contactPreferences.map((pref) => (
            <option key={pref.id} value={pref.id}>
              {pref.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isFeatured"
            checked={data?.isFeatured || false}
            onChange={(e) => onChange({ ...data, isFeatured: e.target.checked })}
          />
          <label htmlFor="isFeatured">Destacar anúncio</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" />
        </svg>
        <span>
          Anúncios com fotos recebem até 10x mais visualizações!
        </span>
      </div>
    </div>
  );
}
